/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_F_GpsInputs */

const cs_pm_f_gps = /** @type {(inputs: Pm_F_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPS`)
};

const en_pm_f_gps = /** @type {(inputs: Pm_F_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GPS`)
};

/**
* | output |
* | --- |
* | "GPS" |
*
* @param {Pm_F_GpsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_f_gps = /** @type {((inputs?: Pm_F_GpsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_F_GpsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_f_gps(inputs)
	return cs_pm_f_gps(inputs)
});